import React from 'react';
import Layout from '../layouts';
import DistLayout from '../layouts/district';

import Home from '../pages/Home';
import AboutUs from '../pages/About-us';
import Blogs from '../pages/News';
import BlogSingle from '../pages/News/_id';
import OurGallery from '../pages/Gallery';
import ContactUs from '../pages/Contact-us';
import District from '../pages/District';
import GalleryDetails from '../pages/Gallery/_slug';
import Video from '../pages/Video';
import Notice from '../pages/Notice';
import NoticeSingle from '../pages/Notice/_id';
import PR from '../pages/Press-releases';
import Downloads from '../pages/Downloads';
import Page from '../pages/Page/_slug';
import FAQ from '../pages/FAQ';
import Branch from '../pages/Branches';
import ProvinceLayout from '../layouts/province';
import SearchPage from '../pages/Search';
import MemberDetails from '../pages/member';

interface route {
  name: string,
  path: string,
  layout: React.FC,
  component: React.FC,
  isProvince: boolean
}

const Routes: Array<route> = [
  {
    name: "Home",
    path: '/',
    layout: Layout,
    component: Home,
    isProvince: false
  },

  {
    name: "About Us",
    path: '/about-us',
    layout: Layout,
    component: AboutUs,
    isProvince: false
  },

  {
    name: "Blogs",
    path: '/news',
    layout: Layout,
    component: Blogs,
    isProvince: false
  },

  {
    name: "Branches",
    path: '/election-offices',
    layout: Layout,
    component: Branch,
    isProvince: false
  },

  {
    name: "Blogs",
    path: '/news/:slug',
    layout: Layout,
    component: BlogSingle,
    isProvince: false
  },

  {
    name: "Gallery",
    path: '/gallery',
    layout: Layout,
    component: OurGallery,
    isProvince: false
  },
  {
    name: "Gallery details",
    path: '/gallery/:slug',
    layout: Layout,
    component: GalleryDetails,
    isProvince: false
  },
  {
    name: "Notice",
    path: '/notice',
    layout: Layout,
    component: Notice,
    isProvince: false
  },

  {
    name: "Press release",
    path: '/press-release',
    layout: Layout,
    component: PR,
    isProvince: false
  },

  {
    name: "Notice",
    path: '/notice/:slug',
    layout: Layout,
    component: NoticeSingle,
    isProvince: false
  },

  {
    name: "Downloads",
    path: '/downloads',
    layout: Layout,
    component: Downloads,
    isProvince: false
  },

  {
    name: "Contact us",
    path: '/contact-us',
    layout: Layout,
    component: ContactUs,
    isProvince: false
  },

  {
    name: "FAQs",
    path: '/faqs',
    layout: Layout,
    component: FAQ,
    isProvince: false
  },



  {
    name: "Video",
    path: '/videos',
    layout: Layout,
    component: Video,
    isProvince: false
  },

  {
    name: "Page",
    path: '/page/:slug',
    layout: Layout,
    component: Page,
    isProvince: false
  },

  // district
  {
    name: "District",
    path: '/district/:dist_slug',
    layout: DistLayout,
    component: District,
    isProvince: false
  },
  {
    name: "Video",
    path: '/district/news/:dist_slug',
    layout: DistLayout,
    component: Blogs,
    isProvince: false
  },

  {
    name: "District",
    path: '/district/gallery/:dist_slug',
    layout: DistLayout,
    component: OurGallery,
    isProvince: false
  },

  {
    name: "Notice",
    path: '/district/notice/:dist_slug',
    layout: DistLayout,
    component: Notice,
    isProvince: false
  },

  {
    name: "Press release",
    path: '/district/press-release/:dist_slug',
    layout: DistLayout,
    component: PR,
    isProvince: false
  },

  {
    name: "Video",
    path: '/district/videos/:dist_slug',
    layout: DistLayout,
    component: Video,
    isProvince: false
  },

  {
    name: "Downloads",
    path: '/district/downloads/:dist_slug',
    layout: DistLayout,
    component: Downloads,
    isProvince: false
  },
  //province
  {
    name: "District",
    path: '/province/:dist_slug',
    layout: ProvinceLayout,
    component: District,
    isProvince: true
  },
  {
    name: "Video",
    path: '/province/news/:dist_slug',
    layout: ProvinceLayout,
    component: Blogs,
    isProvince: true
  },

  {
    name: "District",
    path: '/province/gallery/:dist_slug',
    layout: ProvinceLayout,
    component: OurGallery,
    isProvince: true
  },

  {
    name: "Notice",
    path: '/province/notice/:dist_slug',
    layout: ProvinceLayout,
    component: Notice,
    isProvince: true
  },

  {
    name: "Press release",
    path: '/province/press-release/:dist_slug',
    layout: ProvinceLayout,
    component: PR,
    isProvince: true
  },

  {
    name: "Video",
    path: '/province/videos/:dist_slug',
    layout: ProvinceLayout,
    component: Video,
    isProvince: true
  },

  {
    name: "Downloads",
    path: '/province/downloads/:dist_slug',
    layout: ProvinceLayout,
    component: Downloads,
    isProvince: true
  },

  {
    name: "Search",
    path: '/search',
    layout: Layout,
    component: SearchPage,
    isProvince: false
  },

  {
    name: "Member",
    path: '/member/:id',
    layout: Layout,
    component: MemberDetails,
    isProvince: false
  },



]


export default Routes;